// extracted by mini-css-extract-plugin
export default {"primary":"bloggerStatistics_primary__6IjRp","secondary":"bloggerStatistics_secondary__BImwH"};